// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_mpq7k","sub_logo":"index_sub_logo_CZvZ1","breadcrumbs":"index_breadcrumbs_P0Zfw"};